import ChainPerformance from './ChainPerformance';
import './ChainPerformance.scss';

export default ChainPerformance;